@if (vm(); as vm) {
@if (vm.offerList?.offers?.length > 0) {
@for (offer of vm.offerList.offers; track $index) {
<app-offer
  [offer]="offer"
  [baseurl]="baseurl"
  [user]="vm.user"
  [offerPerformanceData]="vm.offerList.offerPerformanceData"
/>
}
} @else {
<p>
  Unfortunately, this offer is unavailable for your selected location. Please
  select a different location to check for eligibility.
</p>
}
}
